import React from "react";
import ReactDOM from "react-dom";
import {observer, inject} from "mobx-react";
import {observable, computed} from 'mobx';
import ReactDataSheet from "@components/react-datasheet";
import axios from "axios";
import getBoxPadUrl from "@utils/getBoxPadUrl"

function widthStyle(cell) {
    const width = typeof cell.width === 'number' ? cell.width + 'px' : cell.width;
    return width ? {width} : null;
}

@observer
class SimpleTouchEditor extends React.Component {
    //	@observable data = [];
    constructor(props) {
        super(props);
        this.handleCommit = this.handleCommit.bind(this);
        this.handleCellFocus = this.handleCellFocus.bind(this);
        this.state = {activeRow: 0, activeCell: 0};
    }


    handleCommit(e, row, col, value, rowStep, colStep) {
        //console.debug("handleCommit", this.props, e.keyCode, e.which, e); //this.props.data[row][col], value);
        const {onCellsChanged} = this.props;

        onCellsChanged([{cell: this.props.data[row][col], value: value}]);

        if (rowStep || colStep) {
            this.setState({activeRow: row + rowStep, activeCell: col + colStep});
        }

        //if (e.which === 13) {
        //    this.setState({ activeRow: ++row, activeCell: col });
        //    // Todo, acttiveRow > length?...
        //}
    }

    handleCellFocus(e, row) {
        //console.log("handleCellFocus", row);
        this.setState({activeRow: row});
    }

    render() {


        return (
            <span tabIndex="0" className="data-grid-container">
                <table className="data-grid text-xs">
                    <tbody>
                        {this.props.data.map((row, rowIndex) => (
                            <tr key={"row_" + rowIndex}>
                                {row.map((cell, cellIndex) => {

                                    const className = [
                                        cell.className,
                                        'cell', cell.overflow,
                                        cell.readOnly && 'read-only',
                                        cell.quantityDiff && 'quantity-diff'
                                    ].filter(a => a).join(' ');

                                    return (
                                        <td key={"cell_" + cellIndex}
                                            className={className}
                                            style={widthStyle(cell)}>

                                            {cell.readOnly
                                                ? <span className="value-viewer">{cell.value}</span>

                                                : <SimpleTouchEditorCell
                                                    handleCommit={this.handleCommit}
                                                    handleCellFocus={this.handleCellFocus}
                                                    rowIndex={rowIndex}
                                                    cellIndex={cellIndex}
                                                    activeRow={this.state.activeRow}
                                                    activeCell={this.state.activeCell}

                                                    value={cell.value}
                                                />}

                                        </td>
                                    );
                                })}
                            </tr>
                        ))}




                    </tbody>
                </table>
            </span>);

    }

}

class SimpleTouchEditorCell extends React.Component {


    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onHandleCommit = this.onHandleCommit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.state = {value: props.value, hasFocus: false};
        this.tabNext = false;
        this.tabPrevious = false;
    }


    handleFocus(event) {
        const {handleCellFocus} = this.props;
        handleCellFocus(event, this.props.rowIndex);

        //console.log("handleFocus", event.target.value);
        event.target.placeholder = this.state.value;//event.target.value;

        event.target.value = "";
        //event.target.select();
    }


    handleChange(value) {
        //console.log("handleChange", value);
        this.setState({value: value});
    }

    handleKeyPress(e) {
        //console.log("handleKeyPress", e.which, e.keyCode, this.props);
        const keyCode = e.which || e.keyCode;
        //const { handleKeyPress } = this.props;
        if (keyCode === 13) {
            this.onHandleCommit(e);
        }
    }

    handleKeyDown(e) {
        //console.log("handleKeyDown", e.key, e);

        if (e.key === "Tab" && e.shiftKey) {
            this.tabPrevious = true;
        } else if (e.key === "Tab") {
            this.tabNext = true;
            //console.log("Tab pressed");
        }

    }

    componentWillReceiveProps(nextProps) {
        //console.log("componentWillReceiveProps", nextProps);

        if (this.state.hasFocus === false && nextProps.activeRow === this.props.rowIndex && nextProps.activeCell === this.props.cellIndex) {
            this.setState({hasFocus: true});
            this.takeFocus();
            //console.log("takeFocus:", nextProps.activeRow);

        } else if (nextProps.activeRow !== this.props.rowIndex || nextProps.activeCell !== this.props.cellIndex) {
            this.setState({hasFocus: false});
            //console.log("lostFocus:", nextProps.activeRow);
        }


        if (
            //nextProps.activeRow !== this.props.rowIndex && 
            nextProps.value !== this.state.value) {
            this.setState({value: nextProps.value});
        }


        //if (nextProps.value !== this.state.value && nextProps.value !== this._input.placeholder) {
        ////    this.setState({ value: nextProps.value });
        //}
    }

    shouldComponentUpdate(nextProps, nextState) {
        //	console.log("shouldComponentUpdate", nextProps, nextState);
        return nextProps.value !== this.props.value || nextState.value !== this.state.value;
    }


    onHandleCommit(event) {
        const {handleCommit} = this.props;
        let rowStep = 0;
        let colStep = 0;
        if (this.tabNext) {
            //console.log("Tab reset");
            rowStep = 1;
            this.tabNext = false;
        } else if (this.tabPrevious) {
            rowStep = -1;
            this.tabPrevious = false;
        }


        const keyCode = event.which || event.keyCode;
        ///console.log("keyCode, ", keyCode);
        if (keyCode === 13) {
            rowStep = 1;
        }

        //console.log(this.props.value,  this.state.value);

        if (event.target.value === "" && event.target.placeholder.length > 0) {
            event.target.value = event.target.placeholder;
            event.target.placeholder = "";
            return;
        }

        event.target.placeholder = "";

        if (this.props.value !== this.state.value) {
            handleCommit(event, this.props.rowIndex, this.props.cellIndex, this.state.value, rowStep, colStep);
        }
    }


    takeFocus() {

        this._input.focus();
    }


    render() {
        //console.log("render:", this.state.value)
        return (
            <input className="data-editor touch"
                   ref={input => {
                       this._input = input
                   }}
                   type="number"
                   pattern="[0-9]*"
                   onFocus={this.handleFocus}
                   onKeyPress={this.handleKeyPress}
                   onKeyDown={this.handleKeyDown}
                   onChange={(e) => {
                       this.handleChange(e.target.value);
                   }}
                   onBlur={(e) => {
                       this.onHandleCommit(e);
                   }}
                   value={this.state.value}/>
        );
    }
}


@inject("store")
@observer
export default class EditProduct extends React.Component {
    @observable Product = null;
    @observable Siblings = [];
    @observable SplitOrderInformation = [];
    @observable ViewForcastForSku = "";
    @observable ViewOrdersplitForSku = "";
    @observable errorMessage = null;

    @observable OrderStatusId = null;

    @observable processingUpdates = [];
    @observable currentOrderLines = 0;

    constructor(props) {
        super(props);

        this.focusProduct = this.focusProduct.bind(this);
        this.showForecast = this.showForecast.bind(this);
        this.showOrderSplit = this.showOrderSplit.bind(this);
        this.closeEditProducts = this.closeEditProducts.bind(this);

        this.forecastRef = React.createRef();
        this.scrollToForecast = this.scrollToForecast.bind(this);
        // this.getSplitOrderInfo = this.getSplitOrderInfo.bind(this);
//        console.debug("EditProduct.js > constructor > edit product constructor", this.Product);
    }


    

    componentDidMount() {
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        this.currentOrderLines = activeOrder.ProductList.find(product => product.GroupKey === this.props.GroupKey).OrderLines.length;

        this.getProductData(this.props);

    }

    componentWillReceiveProps(nextProps) {
        //console.log("componentWillReceiveProps", nextProps);
        //console.debug("product", this.Product);

        if (!this.Product || nextProps.GroupKey !== this.Product.GroupKey) {
            // Refresh this if the orderstatus is changed or sku is updated
            //console.log("componentWillReceiveProps -> getProductData", nextProps.GroupKey, "thisProduct", this.Product);
            this.getProductData(nextProps);
        }
    }

    componentWillReact() {
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        if(activeOrder) {
            const product = activeOrder.ProductList.find(product => product.GroupKey === this.props.GroupKey);
            const orderLinesCount = product ? product.OrderLines.length : 0;
            if (orderLinesCount !== this.currentOrderLines) {
                this.getProductData(this.props);
                this.currentOrderLines = orderLinesCount;
            }
        }

    }


    stockExceededOrderLine(orderLine) {
        if (!orderLine)
            return "";
        const prop = orderLine.Properties.find(x => x.Key === "_StockExceeded");
        if (prop && prop.Value === "1") {
            return "exceeded";
        }

        return "";
    }


    @computed
    get EditorCells() {
        
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        
        const groupKey = this.props.GroupKey

        // if (!this.Product) {
        //     return null;
        // }

        const navigation = this.props.store.navigation;
        const orderType = activeOrder ? activeOrder.OrderType : null;

        let headerCells = [
            [
                {value: 'Product', readOnly: true, width: "cell-product", overflow: 'nowrap'},
                {value: 'Stock', readOnly: true, className:  "cell-stock", overflow: 'wrap'},
                //{ value: 'Assigned', readOnly: true, className: "cell-quantity-ready-header", overflow: 'clip' },
                {value: 'Order', readOnly: true, className: "cell-quantity", overflow: 'clip'}

            ].filter(x => x !== null)
        ];

        let rowCells = null;
        // const variantGroup1 = this.Product.NewVariantGroups[0];
        // const variantGroup1Name = this.Product.GroupByKeys[0].substr(0, this.Product.GroupByKeys[0].length - 2);
        // const variantGroup2Name = this.Product.GroupByKeys.length > 1
        //     ? this.Product.GroupByKeys[1].substr(0, this.Product.GroupByKeys[1].length - 2)
        //     : null;


        //console.debug("ordertype",orderType); 
        let rows = [];


        if (false && groupKey) {

            rows.push([
                {
                    value: <div className="group-container">
                        <h3>{groupKey}</h3>
                    </div>,
                    readOnly: true,
                    key: 'Name',
                    width: "60%",
                    overflow: 'clip'
                },
                {
                    value: "",
                    key: 'Stock',
                    readOnly: true,
                    width: "10%"
                },

                {
                    value: "",
                    key: 'OriginalQuantity',
                    readOnly: true,
                    width: "10%"
                }
            ]);

            
        }

        const productGroup = activeOrder ? activeOrder.ProductList.find(p => p.GroupKey === groupKey) : null;
        rowCells = [];
        
        if(productGroup === null) {
            return headerCells.concat(rowCells);
        }
        
        
        rows = rows.concat(
            productGroup.OrderLines.map(orderLine => {

                // const productLine = activeOrder
                //     ? activeOrder.ProductList.find(product => product.GroupKey === groupKey)
                //     : null;


                // let orderLine = productLine
                //     ? productLine.OrderLines.find(x => x.Sku === variant.Sku && x.VariantSku === variant.VariantSku)
                //     : null;

                // const orderLines = activeOrder.OrderLinesBySku(variant.Sku, variant.VariantSku);
                // let orderLine = (orderLines && orderLines.length > 0) ? orderLines[0] : null;


                // if (!orderLine) {
                //     // Check processingUpdate - 
                //     var updateRow =
                //         this.processingUpdates.find(x => x.Sku === variant.Sku && x.VariantSku === variant.VariantSku);
                //     orderLine = updateRow;
                // }
                //console.log("order line ", orderLine, variant);


                var stock = {Quantity: "N/A"}; // todo
                // var stock = this.Product.Stock
                //     ? this.Product.Stock.find(x => x.Sku === variant.VariantSku || x.Sku === variant.Sku)
                //     : {Quantity: "N/A"};
                // var forecast = this.Product.Forecast
                //     ? this.Product.Forecast.filter(x => (x.Sku === variant.VariantSku || x.Sku === variant.Sku) && x.Quantity > 0)
                //     : null;
                //
                // let splitOrders = activeOrder
                //     ? activeOrder.SplitOrders.filter((orderVar) => {
                //         var res = orderVar.Orderlines.find((orderlineVar) => {
                //             return orderlineVar.sku === variant.VariantSku;
                //         });
                //         return typeof res !== "undefined";
                //     })
                //     : [];

                // console.debug("splits", splitOrders, variant.VariantSku);

                //var forecastSum = forecast ? forecast.reduce((a, b) => a + b.Quantity, 0) : null;

                return [
                    {
                        value: <div className="detail-container">
                            <img

                                alt={""}
                                style={{width: 40, float: "left", marginRight: 7}}
                                className={""}
                                src={orderLine.PrimaryImageUrl
                                    ? getBoxPadUrl(orderLine.PrimaryImageUrl,
                                        160,
                                        240,
                                        "jpg",//navigation.ImageFormat,
                                        "ffffff").url
                                    : "/umbraco/Ucommerce/images/ui/image-not-found.png"
                                }/>
                            <span className="title">{orderLine.Name}</span>
                            <br/><span className="detail">{orderLine.VariantSku || orderLine.Sku}</span>
                            <br/><span className="detail">{orderLine.PriceExFormatted}</span></div>,
                        readOnly: true,
                        key: 'Name',
                        className: "cell-product",
                        overflow: 'clip'
                    },
                    {
                        value: <React.Fragment>
                            <div style={{position: 'relative'}}>
                                <span>{stock && stock.Quantity}<br/></span>
                            </div>
                        </React.Fragment>,
                        key: 'Stock',
                        readOnly: true,
                        className: "cell-stock"
                    },
                    /*
                    {
                        value: activeOrder === null
                            ? ""
                            : orderLine ? orderLine.Quantity : "",
                        forceComponent: true,
                        readOnly: true,
                        key: 'Ready',
                        VariantSku: variant.VariantSku,
                        Sku: variant.Sku,
                        className: (orderLine &&
                            ((typeof orderLine.QuantityDiff === "number") && orderLine.QuantityDiff > 0)
                            ? "cell-quantity-ready cell-quantity-diff"
                            : "cell-quantity-ready")

                    }
                    */
                    {
                        value: activeOrder === null
                            ? "No active order"
                            : (orderLine ? orderLine.Quantity : 0),//variant.PriceEx === 0 ? "N/A " + (orderLine ? ("(" + orderLine.Quantity + " added)") : "") : (orderLine ? orderLine.OriginalQuantity : 0),
                        forceComponent: true,
                        readOnly: !activeOrder || (activeOrder.Readonly), // || variant.PriceEx === 0), // Checked out, make values readOnly
                        key: 'Quantity',
                        GroupKey: groupKey,
                        VariantSku: orderLine.VariantSku,
                        Sku: orderLine.Sku,
                        OrderLineId: (orderLine ? orderLine.OrderLineId : null),
                        className: ("cell-quantity " + this.stockExceededOrderLine(orderLine))
                    }
                ].filter(x => x !== null);
            }));


        rowCells = rows;

        //console.l("editorCells", editorCells, headerCells);
        //console.log("rowCells", rowCells);
        return headerCells.concat(rowCells);
    }

    componentWillUnmount() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to component unmount.');
            console.debug("request cancelled");
        }
    }


    getProductData(props) {
        // save the new request for cancellation
        this.processingUpdates = [];
        this.errorMessage = null;
        const currentOrder = props.currentOrder;

        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
            console.debug("request cancelled");
        }

        this._source = axios.CancelToken.source();

        this.Product = null;
        this.Siblings = [];

        // this.Product = Product.create({
        //    
        // });

        //
        // this.props.store.order.getProductGroup(props.GroupKey, this._source.token).then(res => {
        //
        //     if (res) {
        //         this.Product = Product.create(res);
        //
        //         //this.Product = res.product;
        //         //this.Siblings = res.siblings;
        //         this.OrderStatusId = currentOrder ? currentOrder.OrderStatusId : 0;
        //     }
        // },
        //     error => {
        //         console.log("getProductData response error ", error);
        //         if (!axios.isCancel(error)) {
        //             //alert("axios: " + error.message);
        //             this.errorMessage = error.message;
        //         }
        //     }
        // );
    }

    cellChanges(changes, order) {

        const updateObject = changes.map(change => ({
            GroupKey: change.cell.GroupKey,
            Sku: change.cell.Sku,
            VariantSku: change.cell.VariantSku,
            //Quantity: change.value,
            OriginalQuantity: change.value,
            OrderLineId: change.cell.OrderLineId
        }));

        // Add update to temporary processingUpdates. This allows the gui to display a value to the user while the quantity is being updated on the server

        updateObject.forEach(x => {
            const existingUpdate = this.processingUpdates.find(pU => pU.Sku === x.Sku && pU.VariantSku === x.VariantSku);

            if (existingUpdate) {
                existingUpdate.OriginalQuantity = x.OriginalQuantity;
                //existingUpdate.Quantity = x.Quantity;
            } else {
                this.processingUpdates.push(x);

                //console.log("processingUpdates", this.processingUpdates);


            }
        });
        order.updateQuantities(updateObject);
    }


    focusProduct(e, product) {
        e.preventDefault();
        const {navigation} = this.props.store;
        navigation.openProductDialog(product.Sku);
    }

    showForecast(e, sku) {
        e.preventDefault();

        //console.log("showForecast", variantSku);
        this.ViewForcastForSku = sku;
        this.scrollToForecast();
    }

    showOrderSplit(e, sku) {
        e.preventDefault();

        //console.log("showForecast", variantSku);
        this.ViewOrderSplitForSku = sku;
        //this.scrollToForecast();
    }

    scrollToForecast() {
        const myDomNode = ReactDOM.findDOMNode(this.forecastRef.current);
        const smooth = true;
        const behavior = smooth ? 'smooth' : 'instant';
        const options = {behavior};
        // scroll to top
        options.block = 'end';
        //options.inline = 'nearest';

        setTimeout(() => {
            myDomNode.scrollIntoView(options);
        }, 500);
    }


    closeEditProducts(e) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.closeToolbar();
    }


    render() {

        const orderStore = this.props.store.order;
        const navigation = this.props.store.navigation;

        const product = this.Product;
        const siblings = this.Siblings;
        const order = orderStore.activeOrder;

        const showDetails = this.props.showDetails || false;

        if (this.errorMessage) {
            return (<div>Error: {this.errorMessage}</div>);
        }


        if (!this.EditorCells) {
            return (<div>Loading order data...</div>);
        }

        

        return (<React.Fragment>
            {showDetails
                ?

                <React.Fragment>
                    <h5 className="mb-0">{product.GroupKey}</h5>
                    <p className="mb-2">{product.GroupDisplayName}</p>
                    <div className="category-product-container">
                        <div className="product-card mb-30">
                            <div>
                                {siblings.map((sibling, siblingIndex) => {
                                    return (
                                        <a

                                            key={"sibling_" + siblingIndex} href="" onClick={(e) => {
                                            this.focusProduct(e, sibling);
                                        }
                                        }><img
                                            title={sibling.Name + ", " + sibling.Sku}
                                            src={(sibling.PrimaryImageUrl ? sibling.PrimaryImageUrl : "/dist/img/no_image.jpg") + "?width=40"} style={{border: sibling.Sku === product.Sku ? "2px solid #aaa" : "", width: 40, paddingRight: 3}}


                                        /></a>
                                    );
                                })}

                            </div>

                        </div>
                    </div>
                </React.Fragment>

                : null}


            { /* todo: pc with touch screen?*/
            }
            {navigation.deviceIsTouchEnabled
                //isTouchDevice()
                ? <SimpleTouchEditor data={this.EditorCells}
                                     onCellsChanged={changes => this.cellChanges(changes, order)}/>
                : <React.Fragment>
                    <ReactDataSheet

                        data={this.EditorCells}
                        valueRenderer={cell => {
                            return cell.value;
                        }}

                        onCellsChanged={changes => this.cellChanges(changes, order)}

                    />
                </React.Fragment>}
        </React.Fragment>);
    }
}